import { render, staticRenderFns } from "./sub-title.vue?vue&type=template&id=cb9bf35c&scoped=true&"
import script from "./sub-title.vue?vue&type=script&lang=js&"
export * from "./sub-title.vue?vue&type=script&lang=js&"
import style0 from "./sub-title.vue?vue&type=style&index=0&id=cb9bf35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9bf35c",
  null
  
)

export default component.exports